import ModalClose from '@mui/icons-material/CloseRounded';
import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import DialogTitle from '@mui/material/DialogTitle';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { cloneDeep, startCase } from 'lodash';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Image } from 'primereact/image';
import { InputText } from 'primereact/inputtext';
import { ListBox } from 'primereact/listbox';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { demandColumns, demandPartnerColumns, routesColumns, supplyColumns, supplyPartnerColumns } from '../../../assets/const/Constant';
import { DEMAND, DEMAND_PARTNER, ROUTES, SUPPLY, SUPPLY_PARTNER } from '../../../assets/const/reportTypeConst';
import getRequest, { postRequest, putRequest, useApi } from '../../../assets/helper/ApiHandler';
import ExportCSVIcon from '../../../assets/images/icons/export-CSV.svg';
import KebabIcon from '../../../assets/images/icons/kebab.svg';
import SaveAsNewReportIcon from '../../../assets/images/icons/save-as-new-report.svg';
import SaveReportIcon from '../../../assets/images/icons/save-report.svg';
import SavedReportsIcons from '../../../assets/images/icons/saved-reports.svg';
import ScheduleEmailReportIcon from '../../../assets/images/icons/schedule-email-report.svg';
import { getLoggedInUser } from '../../../auth/authUtil';
import useInitialFilter from '../../../hooks/filterHook';
import { setFilters } from '../../../redux/reducer/filterslice';
import BootstrapDateRangePicker from '../../date/BootstrapDateRangePicker';
import Filter from '../../filter/Filter';
import { reportRoutes } from '../../omegaRoutes/ReportRoutes';
import { getReportPageUrlByType } from '../../pageUrls/urls';
import PaginatorTemplate from '../../PanginatorTemplate';
import { demandRequestsBodyTemplate, erpmBodyTemplate, fillRateBodyTemplate, impressionsBodyTemplate, revenueBodyTemplate, rpmrBodyTemplate } from '../../template/PrefixAndSuffixBody';
import EmailReports from './EmailReports';
import moment from 'moment';
import { predefinedRanges } from '../../../assets/const/dateRanges';
import { setEndDate, setReportDates, setStartDate } from '../../../redux/reducer/dateRangeSlice';
import { formatDate } from '../../../assets/helper/dateFormatter';


export default function Reports() {
    const reports = [
        { name: 'Save report', icon: SaveReportIcon },
        { name: 'Save as new report', icon: SaveAsNewReportIcon },
        { name: 'Schedule Email report', icon: ScheduleEmailReportIcon },
        { name: 'Export as CSV', icon: ExportCSVIcon }
    ];
    const [componentToRender, setComponentToRender] = useState(null);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [rowClick, setRowClick] = useState(false);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const label = useSelector(state => state.dateRange.dates.rangeLabel)
    const sd = useSelector(state => state.dateRange.dates.start);
    const ed = useSelector(state => state.dateRange.dates.end);
    const [dates, setDates] = useState({
        rangeLabel: "This week",
        startDate: sd,
        endDate: ed
    });
    const [saveReport, setSaveReportPopup] = useState(false);
    const [savedReport, setSavedReport] = useState(null);
    const [saveReportName, setSaveReportName] = useState(null);
    const [selectedReports, setSelectedReports] = useState(null);
    const [saveAsNewReport, setSaveAsNewReportPopup] = useState(false);
    const [filterToBeApplied, setFilterToBeApplied] = useState(null);
    const [selectedReportsType, setSelectedReportsType] = useState(null);
    const [UpdateReport, setUpdateReportPopup] = useState(false);
    const [dropDownType, setDropDownType] = useState(null);
    const [tableData, setTableData] = useState([]);
    const initFitr = useSelector(state => state.filters.initialFilters);
    const filters = useSelector(state => state.filters.currentFilters);
    const [sidePanel, setSidePanel] = useState({ right: false });
    const navigate = useNavigate();
    const location = useLocation();
    const setInitialFilter = useInitialFilter();
    const toast = useRef(null);
    const dispatch = useDispatch();
    const reportExport = useRef(null);
    const rowData = location.state ? location.state.rowData : null;
    const reportId = location?.state?.reportId;
    const [rows, setRows] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const totalRecords = useSelector(state => state.totalRecords.count);
    const { getUseRequest } = useApi();
    const toastReportSaved = useRef(null);
    const abortControllerRef = useRef(null);
    const [isLoading, setIsloading] = useState([]);
    let type = location.pathname.split("/")[2];
    const [csvData, setCsvData] = useState([]);

    useEffect(() => {
        if (dropDownType === null)
            handleReportTypeByRole();
    }, [])

    useEffect(() => {
        if (selectedReportsType != null && dates.startDate != null && dates.endDate != null) {
            fetchRoutesData(selectedReportsType, dates.startDate, dates.endDate);
        }
    }, [selectedReportsType, dropDownType, rows, currentPage, dates]);

    useEffect(() => {
        if (location?.state?.reportId) {
            if (location.state.reportType === type)
                getSavedReport(location?.state?.reportId);
        } else {
            setSaveReportName(null);
            setFilterToBeApplied(null);
        }
    }, [location?.state?.reportId])

    useEffect(() => {
        let type = location.pathname.split("/")[2];
        let selectedReport = null;
        let valueToBeFilter = '';

        if (type && reportRoutes) {
            switch (type) {
                case SUPPLY:
                    selectedReport = reportRoutes.filter(item => item.field === SUPPLY);
                    valueToBeFilter = rowData?.name || ''
                    break;
                case DEMAND:
                    selectedReport = reportRoutes.filter(item => item.field === DEMAND);
                    valueToBeFilter = rowData?.name || ''
                    break;
                case ROUTES:
                    selectedReport = reportRoutes.filter(item => item.field === ROUTES);
                    valueToBeFilter = rowData?.name || ''
                    break;
                case DEMAND_PARTNER:
                    selectedReport = reportRoutes.filter(item => item.field === DEMAND_PARTNER);
                    valueToBeFilter = rowData?.demandPartnerName || '';
                    break;
                case SUPPLY_PARTNER:
                    selectedReport = reportRoutes.filter(item => item.field === SUPPLY_PARTNER);
                    valueToBeFilter = rowData?.supplyPartnerName || '';
                default:
                    break;
            }
            setInitialFilter(initFitr);
            setSelectedReportsType(selectedReport[0]);
            if (valueToBeFilter != "") filterGlobalValue(valueToBeFilter)
        }
    }, [location.pathname]);

    useEffect(() => {
        setDates({ startDate: sd, endDate: ed });
    }, [sd, ed])


    const filterGlobalValue = (value) => {
        let _filters = cloneDeep(filters);
        _filters.global.value = value;
        dispatch(setFilters(_filters));
        setGlobalFilterValue(value);
    }

    const onGlobalFilterChange = (e) => {
        filterGlobalValue(e.target.value);
    };

    const handleReportTypeByRole = () => {
        let user = getLoggedInUser();
        let filterRoutes = reportRoutes.filter(route =>
            user?.authorities?.some(item => route.permissions.includes(item))
        );
        setDropDownType(filterRoutes)
        setSelectedReportsType(filterRoutes[0])
        // if (!location?.state?.reportId)
        //     navigate(getReportPageUrlByType(filterRoutes[0].field));
    }

    const getSavedReport = async (id) => {

        // if (abortControllerRef.current) {
        //     abortControllerRef.current.abort();
        // }
        // const controllerOne = new AbortController();
        // abortControllerRef.current = controllerOne;
        // let signal = controllerOne.signal;

        try {
            const report = await getUseRequest(`/ui-report-filters/${id}`, null, navigate);
            setAppliedFilter(report);
        } catch (error) {
            toast.current.show({ severity: "error", summary: 'Error', detail: error });
        }
    }

    const setAppliedFilter = (savedReport) => {
        let date = { ...dates };
        if (savedReport?.dateRange != "Custom Range" & savedReport?.startDate === null) {
            const [startDate, endDate] = predefinedRanges[savedReport?.dateRange];
            date = { startDate: startDate, endDate: endDate };
        } else {
            if (savedReport?.startDate != null)
                date = { startDate: savedReport?.startDate, endDate: savedReport?.endDate };
        }

        let type = reportRoutes.filter(item => item.field === savedReport.reportType);

        dispatch(setReportDates({
            rangeLabel: savedReport.dateRange,
            start: formatDate(date.startDate), end: formatDate(date.endDate)
        }));
        setDates(date);
        setSavedReport(savedReport);
        setSelectedReportsType(type[0]);
        setSaveReportName(savedReport.reportName);
        setFilterToBeApplied(savedReport.reportName);
    }

    const fetchRoutesData = async (tab, startDate, endDate) => {
        setIsloading(true)
        let st = moment(startDate).format('YYYY-MM-DD');
        let ed = moment(endDate).format('YYYY-MM-DD');
        try {
            let data = [];
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const controller = new AbortController();
            abortControllerRef.current = controller;
            let signal = controller.signal;


            switch (tab.field) {
                case SUPPLY:
                    data = await getUseRequest(`/report/supply/main?startDate=${st}&endDate=${ed}&page=${currentPage}&size=${rows}&sort=id,desc/`, null, navigate);
                    break;
                case DEMAND:
                    data = await getUseRequest(`/report/demand/main?startDate=${st}&endDate=${ed}&page=${currentPage}&size=${rows}&sort=id,desc`, null, navigate);
                    break;
                case ROUTES:
                    data = await getUseRequest(`/report/routes/main?startDate=${st}&endDate=${ed}&page=${currentPage}&size=${rows}&sort=id,desc`, null, navigate);
                    break;
                case SUPPLY_PARTNER:
                    data = await getUseRequest(`/report/supply-partner/main?startDate=${st}&endDate=${ed}&page=${currentPage}&size=${rows}&sort=id,desc`, null, navigate);
                    break;
                case DEMAND_PARTNER:
                    data = await getUseRequest(`/report/demand-partner/main?startDate=${st}&endDate=${ed}&page=${currentPage}&size=${rows}&sort=id,desc`, null, navigate);
                    break;
                default:
                    data = [];
            }
            setTableData(data);
        } catch (error) {
            if (toast.current) {
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        } finally {
            setIsloading(false)
        }
    };

    const replaceNullWithZero = (rowData, field) => {
        return rowData[field] === null ? 0 : rowData[field];
    };

    const getColumnsList = (type) => {
        switch (type) {
            case SUPPLY:
                return supplyColumns;
            case SUPPLY_PARTNER:
                return supplyPartnerColumns;
            case DEMAND:
                return demandColumns;
            case DEMAND_PARTNER:
                return demandPartnerColumns;
            case ROUTES:
                return routesColumns;
            default:
                return [];
        }
    };


    const footerUpdateReport = (
        <div>
            <Button label="Cancel" className='button-style-2' onClick={() => { setUpdateReportPopup(false); { setSaveReportPopup(false) } }} autoFocus />
            <Button label="Save report" className='button-style-1'
                onClick={(e) => { updateSaveReport(e); setUpdateReportPopup(false) }} autoFocus
            />
        </div>
    );

    const handleLinkClick = (rowData, destination) => {
        let route;
        let state = {};
        switch (destination) {
            case SUPPLY:
                route = '/supply';
                state = { supply: rowData };
                break;
            case ROUTES:
                route = '/routes';
                state = { routes: rowData };
                break;
            case DEMAND:
                route = '/demand';
                state = { demand: rowData };
                break;
            case DEMAND_PARTNER:
                route = '/demand-partner';
                state = { demandPartner: rowData };
                break;
            case SUPPLY_PARTNER:
            default:
                route = '/supply-partner';
                state = { supplyPartner: rowData };
                break;
        }
        navigate(route, { state });
    };


    const reportsTypeTemplate = () => {
        return (
            <Dropdown
                value={selectedReportsType}
                options={dropDownType}
                onChange={(e) => {
                    const selectedItem = e.value;
                    if (selectedItem) {
                        // handleOnReportTypeChange(selectedItem.field)
                        navigate(getReportPageUrlByType(selectedItem.field))
                    }
                }}
                optionLabel="label"
                placeholder="Select a report type"
                className="w-full md:w-14rem"
                style={{ maxHeight: '250px' }}
            />
        );
    };

    const renderColumns = () => {
        const renderLinkOnNameColumn = (col, rowData, destination) => (
            <div className='supplyPartner flex justify-content-left'
                onClick={() => handleLinkClick(rowData, destination)}>
                {rowData[col.field]}
            </div>
        );

        let allColums = getColumnsList(selectedReportsType?.field);
        return (
            allColums.map((col, i) =>
                col.field !== "isEnabled" && col.field !== "status" ?
                    <Column
                        key={i}
                        field={col.field}
                        header={col.name}
                        headerStyle={col.key == 2 || col.key == 1 ? { textAlign: 'left' } : { textAlign: 'right' }}
                        alignHeader={col.key == 2 || col.key == 1 ? "left" : "right"}
                        bodyStyle={col.key == 1 ? { textAlign: 'left' } : { textAlign: 'right' }}
                        body={(rowData, column, i) => {
                            if (column.field === "name" || column.field === "supplyPartnerName" || column.field === "demandPartnerName") {
                                return renderLinkOnNameColumn(column, rowData, selectedReportsType.field);
                            }
                            switch (column.field) {
                                case "isEnabled":
                                    return statusBodyTemplate(rowData);
                                case "erpm":
                                    return erpmBodyTemplate(rowData);
                                case "rpmr":
                                    return rpmrBodyTemplate(rowData);
                                case "fillRate":
                                    return fillRateBodyTemplate(rowData);
                                case "impressions":
                                    return impressionsBodyTemplate(rowData);
                                case "demandRequests":
                                    return demandRequestsBodyTemplate(rowData);
                                case "revenue":
                                    return revenueBodyTemplate(rowData);
                                default:
                                    console.log("default");
                                    return replaceNullWithZero(rowData, column.field);
                            }
                        }}
                        // body={i === 0 ? (rowData) => renderLinkOnNameColumn(col, rowData, selectedReportsType.field) : col.field === 'isEnabled' ? statusBodyTemplate : null}
                    />
                    : null
            )
        )
    };

    const exportCSV = async () => {
        try {
            toast.current.show({ severity: "info", summary: "saving", detail: 'CSV is being exported', life: 800});
            if (dates.startDate && dates.endDate) {
                await fetchCsvData(selectedReportsType, dates.startDate, dates.endDate);
                if(toast.current){
                    toast.current.show({ severity: "success", summary: "success", detail: 'CSV exported successfully'});
                }
            } else {
                console.error('Start date or end date is missing.');
            }
        } catch (error) {
            console.error('Error exporting CSV:', error);
            if (toast.current) {
                toast.current.show({ severity: "error", summary: 'Error', detail: error.message });
            }
        }
    };
    const fetchCsvData = async (tab, startDate, endDate) => {
        let st = moment(startDate).format("YYYY-MM-DD");
        let ed = moment(endDate).format("YYYY-MM-DD");
        try {
            let url = '';
            console.log(tab.field)
            switch (tab.field) {
                case SUPPLY:
                    url = `/report/supply/export?startDate=${st}&endDate=${ed}`;
                    break;
                case DEMAND:
                    url = `/report/demand/export?startDate=${st}&endDate=${ed}`;
                    break;
                case ROUTES:
                    url = `/report/routes/export?startDate=${st}&endDate=${ed}`;
                    break;
                case SUPPLY_PARTNER:
                    url = `/report/supply-partner/export?startDate=${st}&endDate=${ed}`;
                    break;
                case DEMAND_PARTNER:
                    url = `/report/demand-partner/export?startDate=${st}&endDate=${ed}`;
                    break;
                default:
                    throw new Error('Invalid tab selected.');
            }
            const reportingData = await getRequest(url, null, navigate);
            const csvContent = reportingData; // Assumes data is already in CSV format.
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const urlBlob = window.URL.createObjectURL(blob);
            link.setAttribute('href', urlBlob);
            link.setAttribute('download', `report_${st}_to_${ed}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            if (toast.current) {
                toast.current.show({ severity: "error", summary: 'Error', detail: error.message });
            }
        }
    };


    const reportSavedMessage = (event, ref, severity) => {
        ref.current.show({ severity: 'contrast', summary: 'Report saved', detail: 'The report was successfully saved', life: 3000 });
    };

    const toastNewReportSaved = useRef(null);
    const newReportSavedMessage = (event, ref, severity) => {
        ref.current.show({ severity: 'contrast', summary: 'New report saved', detail: 'The Monthly-Revenue report was successfully saved', life: 3000 });
    };

    const headerSaveReport = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="fs-1 white-space-nowrap">Save report</span>
        </div>
    );

    const updateSaveReport = async (e) => {
        let updateFilterProp = { ...savedReport };
        updateFilterProp["id"] = reportId;
        updateFilterProp["reportName"] = saveReportName;
        updateFilterProp["reportType"] = selectedReportsType.field;
        updateFilterProp["filters"] = JSON.stringify({ ...filters });
        updateFilterProp["dateRange"] = label;

        if (label === "Custom Range") {
            updateFilterProp["startDate"] = sd;
            updateFilterProp["endDate"] = ed;
        }
        try {
            toast.current.show({ severity: "info", summary: "saving", detail: 'Report is being saved', life: 500 });
            const report = await putRequest(`/ui-report-filters/${reportId}`, updateFilterProp, navigate);
            if(toast.current){
                toast.current.show({ severity: "success", summary: "Report saved", detail: "The report was successfully saved"});
            }
        } catch (error) {
            toast.current.show({ severity: "error", summary: 'Error', detail: error });
        }
    }

    const handleSaveNewReport = async (e) => {
        let createNewfilterProp = {};
        createNewfilterProp["reportName"] = saveReportName;
        createNewfilterProp["reportType"] = selectedReportsType.field;
        createNewfilterProp["filters"] = JSON.stringify({ ...filters });
        createNewfilterProp["dateRange"] = label;

        if (label === "Custom Range") {
            createNewfilterProp["startDate"] = sd;
            createNewfilterProp["endDate"] = ed;
        }

        try {
            const report = await postRequest(`/ui-report-filters`, createNewfilterProp, navigate);
            newReportSavedMessage(e, toastNewReportSaved, 'success');
            setSaveAsNewReportPopup(false);
        } catch (error) {
            toast.current.show({ severity: "error", summary: 'Error', detail: error });
        }
    };

    const headerSaveAsNewReport = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="fs-1 white-space-nowrap">Save as new report</span>
        </div>
    );

    const footerSaveAsNewReport = (
        <div>
            <Button label="Cancel" className='button-style-2' onClick={() => { setSaveAsNewReportPopup(false); if (saveReport) { setSaveReportPopup(false) } }} autoFocus />
            <Button label="Save as new report" className='button-style-1'
                onClick={(e) => handleSaveNewReport(e)} autoFocus

            />
        </div>
    );

    const reportsTemplate = (option) => {
        return (
            <div className="report-export-btn">
                {
                    option.name == 'Schedule Email report' && <>{['right'].map((anchor) => (<div className='report-btn' key={anchor} onClick={toggleDrawer(anchor, true, 'EmailReports')}><img alt={option.name} src={option.icon} className='' style={{ width: '1.25rem', marginRight: '.5rem' }} />
                        <div>{option.name}</div></div>))} </>}
                {
                    option.name === 'Save report' && (
                        saveReportName ?
                            <div className='report-btn' onClick={() => setUpdateReportPopup(true)}><img alt={option.name} src={option.icon} className='' style={{ width: '1.25rem', marginRight: '.5rem' }} />
                                <div >{option.name}</div></div>
                            : <div className='report-btn disabled'>
                                <img alt={option.name} src={option.icon} className='' style={{ width: '1.25rem', marginRight: '.5rem' }} />
                                <div >{option.name}</div></div>
                    )
                }
                {
                    option.name == 'Save as new report' && <div className='report-btn' onClick={() => setSaveAsNewReportPopup(true)}><img alt={option.name} src={option.icon} className='' style={{ width: '1.25rem', marginRight: '.5rem' }} />
                        <div>{option.name}</div></div>}
                {
                    option.name == 'Export as CSV' && <div className='report-btn' onClick={exportCSV}><img alt={option.name} src={option.icon} className='' style={{ width: '1.25rem', marginRight: '.5rem' }} />
                        <div>{option.name}</div></div>
                }
            </div>
        );
    };

    const toggleDrawer = (anchor, open, component) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setComponentToRender(component);
        setSidePanel({ ...sidePanel, [anchor]: open });
    };

    // const onGlobalFilterChange = (e) => {
    //     const value = e.target.value;
    //     let _filters = { ...filters };
    //     _filters['global'].value = value;
    //     setFilters(_filters);
    //     setGlobalFilterValue(value);
    // };

    const handleOnRowsChange = (newRows) => {
        setRows(newRows.value);
        setCurrentPage(0);
    };

    const handleOnPageChange = (page) => {
        setCurrentPage(page);
    }

    const renderHeader = () => {
        return (
            <>
                <div className="flex justify-content-end" style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div className="flex justify-content-start">
                        <span className="p-input-icon-left header-left-element">
                            {reportsTypeTemplate()}
                        </span>
                    </div>
                    <div className="flex">
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" />
                        </span>
                        <span className="p-input-icon-left">
                            <i className="pi pi-calendar" />
                            <BootstrapDateRangePicker
                            //selectedDate={handleSelectedDate} 
                            />
                        </span>
                        <span className="p-input-icon-left">
                            <Filter
                                columnsList={getColumnsList(selectedReportsType?.field)}
                            />
                        </span>
                        <span className="p-input-icon-left">
                            {['right'].map((anchor) => (<Button type="button" key={anchor} className='filtercontrol-btn' onClick={(e) => reportExport.current.toggle(e)}><Image src={KebabIcon} alt="Image" width="24" /></Button>))}
                        </span>
                        <OverlayPanel ref={reportExport} className='report-export'>
                            <ListBox
                                value={selectedReports}
                                onChange={(e) => setSelectedReports(e.value)}
                                options={reports}
                                optionLabel="name"
                                itemTemplate={reportsTemplate} className="w-full md:w-14rem" listStyle={{ maxHeight: '250px' }} />
                        </OverlayPanel>
                        <span className="p-input-icon-left header-right-element">
                            <Link to='/savedReports'><Button type="button" className='filtercontrol-btn'><Image src={SavedReportsIcons} alt="Image" width="24" /></Button></Link>
                        </span>
                    </div>
                </div>
            </>
        );
    };
    const getSeverity = (status) => {
        switch (status) {
            case 'Active':
                return 'sucess';
            case 'Stopped':
                return 'danger';
        }
    };

    const statusBodyTemplate = (rowData) => {
        return <Tag value={rowData.isEnabled ? "Active" : "Stopped"} severity={getSeverity(rowData.isEnabled)} className={rowData.isEnabled ? 'status status-active' : 'status status-stopped'} />;
    }

    return (
        <div className="card">
            <Toast ref={toast} position="bottom-right"></Toast>
            <Toolbar className='main-content-header'>
                <Typography variant="h6" noWrap component="div" className='main-content-title'>
                    <h2 className='title'>Reports </h2>
                    {filterToBeApplied ?
                        <>
                            <h2 className='divider'>/</h2>
                            <h2 className='sub-title'> {filterToBeApplied}</h2>
                        </>
                        : null
                    }
                </Typography>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    sx={{ mr: 2, display: { sm: 'none' } }}>
                    <MenuIcon />
                </IconButton>
            </Toolbar>
            <DataTable
                value={tableData}
                filters={filters}
                loading={isLoading}
                header={renderHeader()}
                emptyMessage="No customers found."
                selectionMode={rowClick ? null : 'checkbox'}
                selection={selectedProducts}
                onSelectionChange={(e) => setSelectedProducts(e.value)}
                dataKey="id"
                paginator rows={10}
                paginatorTemplate={
                    PaginatorTemplate({
                        currentPage,
                        totalRecords,
                        rows,
                        handleOnRowsChange,
                        handleOnPageChange,
                    })}
                tableStyle={{ minWidth: '50rem' }} resizableColumns
            >
                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                {renderColumns()}
            </DataTable>

            <Dialog
                className='sample-dialog'
                visible={UpdateReport}
                modal
                header={headerSaveReport}
                footer={footerUpdateReport}
                style={{ width: '360px' }}
                onHide={() => setSaveReportPopup(true)}
            >
                <p className="fs-12-500">
                    You have changed the filters on this report. Once saved, the new set of filters will be applied to this report. Do you want to proceed?
                </p>
            </Dialog>
            <Dialog
                className='sample-dialog'
                visible={saveAsNewReport} modal
                header={headerSaveAsNewReport}
                footer={footerSaveAsNewReport}
                style={{ width: '360px' }}
                onHide={() => setSaveAsNewReportPopup(true)}
            >
                <p className="fs-12-500">Enter the name of the new report</p>
                <InputText placeholder="Enter Report Name" onChange={(e) => setSaveReportName(e.target.value)} />
            </Dialog>
            <Toast ref={toastReportSaved} position="bottom-right" />
            <Toast ref={toastNewReportSaved} position="bottom-right" />

            {['right'].map((anchor) => (
                <Drawer key={anchor}
                    anchor={anchor}
                    open={sidePanel[anchor]}
                    onClose={toggleDrawer(anchor, false)}>
                    <Box className='drawerHeader'>
                        <DialogTitle >Schedule Reports</DialogTitle>
                        <ModalClose className='drawerClose' onClick={toggleDrawer(anchor, false)} />
                    </Box>
                    {componentToRender === 'EmailReports' && <EmailReports toggleDrawer={toggleDrawer(anchor,)} />}
                </Drawer>
            ))}
        </div>
    )
}
